<!-- <div class="modal-header">
<h4 class="modal-title" id="modal-title"></h4>
</div>
<div class="modal-body">
  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 575px;">

    <div class="spinner-grow" role="status">
      <span class="visually-hidden align-item-center"></span>
    </div>

  </div>
  <div *ngIf="!isLoading">
    <iframe [src]="url"  style="width:100%; height:575px;" frameborder="0"></iframe>
  </div>
</div>
<div class="modal-footer text-right">
</div> -->
<div class="modal-header">
  <h4 class="modal-title" id="modal-title"></h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  @if (isLoading) {
    <div class="d-flex justify-content-center align-items-center" style="height: 575px;">
      <!-- <p>Loading...</p> -->
      <div class="spinner-grow" role="status">
        <span class="visually-hidden align-item-center"></span>
      </div>
    </div>
  }
  @if (!isLoading) {
	@if (isImage) {
		<!-- rendered directly: a document viewer cannot display an image -->
		<div class="file-view-image">
			<img [src]="imageUrl" alt="Attachment preview"
				(error)="onImageError()" />
		</div>
	}
	@else {
			<!-- PDFs and documents alike: browsers render PDFs natively here, and
			     the Office/Google viewers are themselves iframes -->
			<iframe [src]="url" #iframeRef title="File preview"
				style="width:100%; height:575px; border:0;"></iframe>
	}

  }
</div>
<div class="modal-footer text-right">
</div>

